import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { TweenLite } from 'gsap';

class AnimatedText extends Component {
	constructor(props) {
		super(props);
		const output = props.open ? props.children : null;
		const length = props.children.length;
		this.tweenObj = { index: (props.open)? length : 0 };
		this.tweenInst = null;
		this.state = {
			tweening: true,
			output: output
		}
	}
	tween = ( action = "open" ) => {
		const full_length = this.props.children.length;
		const tweenDur = (this.props.transitionTime) ? (this.props.transitionTime/100) : full_length * 0.002;
		this.setState({ tweening: true });
		this.tweenInst = TweenLite.to( this.tweenObj, tweenDur, {
			onUpdate: this.updateOutput,
			onComplete: this.updateComplete,
			ease: 'Linear.easeNone',
			index: (action === "open")? full_length : 0
		})
	}
	updateOutput = () => {
		const endIndex = Math.ceil( this.tweenObj.index );
		const segment = this.props.children.slice(0, endIndex);
		this.setState({ output: segment });
	}
	updateComplete = () => {
		this.setState({ tweening: false });
		if ( this.props.onTransitionEnd ) this.props.onTransitionEnd();
	}
	componentDidUpdate(prevProps) {
		const action = (this.props.open)? "open" : "close";
		if (prevProps.open !== this.props.open) {
			this.tween( action );
		}
	}
	componentWillUnmount() {
		if ( this.tweenInst ) { this.tweenInst.kill(); this.tweenInst = null; }
	}
	render() {
		let classes = ["AnimatedText"];
		if (this.props.className) classes.push(this.props.className);
		if (this.state.tweening) {
			classes.push( (this.props.open)? "is-opening" : "is-closing" );
		} else {
			classes.push( (this.props.open)? "is-open" : "is-closed" );
		}
		return <span className={classes.join(" ")}>{this.state.output}</span>
	}
}
AnimatedText.propTypes = {
	children: PropTypes.string.isRequired,
	open: PropTypes.bool,
	transitionTime: PropTypes.number,
	onTransitionEnd: PropTypes.func,
}
AnimatedText.defaultProps = {
	open: true
}

export default AnimatedText;


// WEBPACK FOOTER //
// ./src/components/common/AnimatedText.jsx